import React from 'react';

import PropTypes from 'prop-types';

import productStyles from '../../styles.module.scss';

export default function ProductFieldRow({
  title, children, className, dataQa,
}) {
  return (
    <div
      className={className || productStyles.row}
      data-qa={dataQa || `product-field-${title}`}
    >
      {children}
    </div>
  );
}

ProductFieldRow.defaultProps = {
  className: '',
  dataQa: '',
};

ProductFieldRow.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  dataQa: PropTypes.string,
};
